<template>
  <div id="app">
    <keep-alive >
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>

    <router-view v-if="!$route.meta.keepAlive" />
    <transition name="slideShow">
      <div class="qrpop" v-if="qrShow">
        <div class="img">
          <img :src="qrimg"/>
        </div>
        <div class="close flex jc" @click="closeQr" v-if="false">
          <span class="iconfont icon-close"></span>
        </div>
      </div>
    </transition>

    <transition name="slideShow">
      <div class="qr-small flex jc" v-if="!qrShow" @click="qrShow=true">
        <span class="iconfont icon-QR-code"></span>
      </div>
    </transition>

    </div>
 </template>

<script>
import qrimg from "@/assets/images/qrimg2.png"
import { mapGetters, mapMutations, mapState } from 'vuex'
export default {
  components: {},
  data() {
    return {
      qrimg,
      qrShow:window.device!='pc'?false:true
    }
  },
  watch:{

  },
  mounted() {
    window.openid = this.$utils.getParams('openid');
    console.log(window.openid,'==window.openid')
    window.onload = function() { // 阻止双击放大 
      var lastTouchEnd = 0;
      document.addEventListener('touchstart',(event)=> {
        if (event.touches.length > 1) { 
        event.preventDefault(); 
        } 
      });
      document.addEventListener('touchend', function(event) { 
        var now = (new Date()).getTime(); if (now - lastTouchEnd <= 300) {
        event.preventDefault(); 
        } lastTouchEnd = now;
      }, false); 
    }
  },
  methods: {
    ...mapMutations(['audio/updatePlayState']),
    closeQr(){
      this.qrShow= false
    }
  },
}
</script>
<style lang="scss" scoped>
#app{
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  position: relative;
}
  .qrpop{
    position: absolute;
    right: 10px;
    bottom: 10px;
    z-index: 9999;
    .van-overflow-hidden &{
      display: none;
    }
    .img{
      border-radius: 10rem;
      overflow: hidden;
      box-shadow: 0 0 10rem rgba($color: #000000, $alpha: 0.3);
    }
    img{
      width: 140rem;
      height: 140rem;
    }
    .close{
      position: absolute;
      right: 0;
      top: -40rem;
      width: 30rem;
      height: 30rem;
      border-radius: 100%;
      background: #fff;
      box-shadow: 0 0 10rem rgba($color: #000000, $alpha: 0.3);
      cursor: pointer;
    }

  }
  .qr-small{
    position: absolute;
    right: 0;
    bottom: 210rem;
    z-index: 99999;
    background: #fff;
    border-radius: 10rem 0 0 10rem;
    box-sizing: border-box;
    padding: 10rem 20rem 10rem 10rem;
    cursor: pointer;
    box-shadow: 0 0 10rem rgba($color: #000000, $alpha: 0.3);
    span{
      font-size: 20rem;
    }
  }
  [data-device='phone'],[data-device='pad']{
    .qrpop ,.qr-small {
      display: none;
    }
    #app{
      height: auto;
    }
  }
  [data-device='pad11']{
    .qrpop{
      img{
        width:100rem;
        height: 100rem;
      }
      .close{
        width: 20rem;
        height: 20rem;
        top: -25rem;
      }
    }
    .qr-small{
      bottom: 100rem;
      padding: 5rem 10rem 5rem 5rem;
      span{
        font-size: 14rem;
      }
    }
  }

  .slideShow-enter-active,
  .slideShow-leave-active {
    transition: all 0.35s;
  }

  .slideShow-enter,
  .slideShow-leave-to {
    opacity: 0;
    right: -220rem;
  }

  .slideDown-enter-active,
  .slideDown-leave-active{
    top: calc(100% - 10rem);
    transition: all 0.35s ease-in-out;

  }
  .slideDown-enter,.slideDown-leave-to{
    top:20rem ;
  }
</style>

